import React, { useState, useEffect } from 'react';
import Heloers from 'utils/helpers';

export function Tabs(props) {
  const [childTabs, setChildTabs] = useState([]);
  const [childContent, setChildContent] = useState();
  const [childValue, setChildValue] = useState();

  let currentValue;
  if (props.selection) {
    currentValue = props.selection;
  }
  else if (props.defaultSelection && !childValue) {
    currentValue = props.defaultSelection;
  }
  else if (childValue) {
    currentValue = childValue;
  }
  else {
    //Need a non-empty default otherwise no tabs will render
    currentValue = '__INVALIDVALUE__';
  }

  useEffect(() => {
    const tabs = [];
    let tab = null;
    React.Children.forEach(props.children, (child) => {
      tabs.push({
        title: child.props.title,
        className: child.props.className,
        value: child.props.value,
        disabled: props.disabled || child.props.disabled,
        active: child.props.value === currentValue,
      });
      if (child.props.value === currentValue) {
        tab = child.props.children;
      }
    });
    setChildTabs(tabs);
    setChildContent(tab)
  }, [currentValue, props.disabled, props.children]);

  const getClass = () => {
    let classNames = [props.className, 'nav', 'nav-tabs'];
    if (props.fill) {
      classNames.push('nav-fill');
    }
    if (props.disabled) {
      classNames.push('nav-tabs-disabled');
    }
    else if (props.variant) {
      classNames.push(`nav-tabs-${props.variant}`);
    }
    else {
      classNames.push('nav-tabs-default');
    }
    return Heloers.String.join(classNames);
  };

  const handleSelect = (value) => {
    setChildValue(value);
    if (props.onSelect) {
      props.onSelect(value);
    }
  };

  return (
    <>
      <nav className={getClass()}>
        {childTabs.map((item, index) => (
          <TabLink {...item} onClick={() => handleSelect(item.value)} key={index} />
        ))}
      </nav>
      <div className='tab-content'>
        <div className='tab-pane active'>
          {childContent}
        </div>
      </div>
    </>
  );
}

function TabLink(props) {
  const handleClick = () => {
    if (props.disabled) {
      return;
    }
    if (props.onClick) {
      props.onClick();
    }
  };

  const getClass = () => {
    let classNames = [props.className, 'nav-item', 'nav-link'];
    if (props.disabled) {
      classNames.push('disabled');
    }
    if (props.active) {
      classNames.push('active');
    }
    return Heloers.String.join(classNames);
  };

  return (
    <div className={getClass()} onClick={handleClick}>
      {props.title}
    </div>
  );
}

export function Tab() {
  return null;
}

/*export function OldTabs(props) {
  const [childTabs, setChildTabs] = useState([]);
  const [childValue, setChildValue] = useState();
  const disabled = props.disabled;

  let currentValue;
  if (props.selection) {
    currentValue = props.selection;
  }
  else if (props.defaultSelection && !childValue) {
    currentValue = props.defaultSelection;
  }
  else if (childValue) {
    currentValue = childValue;
  }
  else {
    //Need a non-empty default otherwise no tabs will render
    currentValue = '__INVALIDVALUE__';
  }

  useEffect(() => {
    const tabs = [];
    if (currentValue) {
      React.Children.forEach(props.children, (child) => {
        tabs.push({
          ...child,
          props: {
            title: child.props.title,
            tabClassName: child.props.className,
            eventKey: child.props.value,
            disabled: disabled || child.props.disabled,
            children: (child.props.value === currentValue) ? child.props.children : <EmptyChild />,
          }
        });
      });
    }
    setChildTabs(tabs);
  }, [currentValue, disabled, props.children]);

  const handleSelect = (value) => {
    setChildValue(value);
    if (props.onSelect) {
      props.onSelect(value);
    }
  };

  const getClass = () => {
    if (props.disabled) {
      return Heloers.String.join(['nav-tabs-disabled', props.className]);
    }
    else if (props.variant) {
      return Heloers.String.join([`nav-tabs-${props.variant}`, props.className]);
    }
    else {
      return Heloers.String.join(['nav-tabs-default', props.className]);
    }
  };

  return (
    <BootstrapTabs className={getClass()} activeKey={currentValue} onSelect={handleSelect} fill={props.fill}>
      {childTabs}
    </BootstrapTabs>
  );
}

export function Tab(props) {
  //This component is never actually rendered, must be created dynamically inside of BootstrapTabs
  //    title={props.title}
  //    tabClassName={props.className}
  //    disabled={props.disabled}
  //    eventKey={props.value}>
  return null;
}

function EmptyChild(props) {
  //Using very tall tab contents inside of the non-active tabs will prevent page scrolling problems caused by resizing
  //Shrinking contents work fine but growing contents cause problems
  return <div style={{ height: 9999 }}></div>;
}*/